import aframe from 'aframe';
import { instantiate } from '@micosmo/aframe/lib/utils';
import { bindEvent } from 'aframe-event-decorators';

let instance = undefined;

aframe.registerComponent('level', {
  schema: {
    duration: {
      type: 'number',
      default: 30000,
    },
    waveSize: {
      type: 'number',
      default: 4,
    },
    generatorConfig: {
      type: 'string',
    },
  },
  init() {
    if (instance !== undefined && instance !== this) {
      throw new Error('Can only have one level component in scene.');
    }
    instance = this;
    this.levelStarted = false;
  },
  update(oldData) {
    if (this.levelStarted) {
      throw new Error('Cannot edit level after it has started.');
    }
    this.play();
  },

  play() {
    if (!this.levelStarted) {
      this.startLevel();
    }
  },

  startLevel() {
    this.missileSpawner = document.querySelector(
      '[missile-spawn-zone]'
    ).components['missile-spawn-zone'];
    this.bomberSpawner = document.querySelector(
      '[bomber-spawn-zone]'
    ).components['bomber-spawn-zone'];

    this.liveMissiles = 0;
    this.liveBombers = 0;
    this.allEnemies = new Set();
    this.timer = 0;

    this.waveQueueEl = this.instantiateWaveQueue(
      JSON.parse(this.data.generatorConfig)
    );

    this.levelStarted = true;
  },
  endLevel() {
    this.el.removeChild(this.waveQueueEl);
    this.waveQueueEl = undefined;
    this.levelStarted = false;
  },
  tick(time, dt) {
    if (!this.levelStarted) {
      return;
    }

    const queue =
      this.waveQueueEl.components && this.waveQueueEl.components['wave-queue'];
    if (!queue) {
      return; // queue not ready yet
    }

    if (this.liveMissiles <= this.data.waveSize - 3) {
      const missiles = queue.take('missile', 4);
      missiles.forEach(m => this.missileSpawner.spawnMissile(m.data));
    }

    const bombers = queue.take('bomber', 1);
    bombers.forEach(b => this.bomberSpawner.spawnBomber(b.data));

    const smartMissiles = queue.take('smart-missile', 1);
    smartMissiles.forEach(sm =>
      this.missileSpawner.spawnSmartMissile(sm.data)
    );

    this.timer += dt;
    if (this.timer >= this.data.duration) {
      document
        .querySelector('[game-state]')
        .setAttribute('game-state', 'state', 'LevelComplete');
    }

    if (queue.isDone() && this.allEnemies.size === 0) {
      this.timer = Math.max(this.data.duration - 2000, this.timer); // 2 seconds before level complete
    }
  },
  missilespawned: bindEvent(function (evt) {
    const missile = evt.detail;
    if (!missile.isPlayer) {
      this.allEnemies.add(missile);
      this.liveMissiles += 1;
    }
  }),
  missileremoved: bindEvent(function (evt) {
    const missile = evt.detail;
    if (!missile.isPlayer) {
      this.liveMissiles -= 1;
      this.allEnemies.delete(missile);
    }
  }),
  bomberspawned: bindEvent(function (evt) {
    const bomber = evt.detail;
    this.allEnemies.add(bomber);
    this.liveBombers += 1;
  }),
  bomberremoved: bindEvent(function (evt) {
    const bomber = evt.detail;
    this.liveBombers -= 1;
    this.allEnemies.delete(bomber);
  }),
  smartmissilespawned: bindEvent(function (evt) {
    const smartMissile = evt.detail;
    this.allEnemies.add(smartMissile);
  }),
  smartmissileremoved: bindEvent(function (evt) {
    const smartMissile = evt.detail;
    this.allEnemies.delete(smartMissile);
  }),
  remove() {
    instance = undefined;
    if (this.waveQueueEl) {
      this.el.removeChild(this.waveQueueEl);
    }
  },
  instantiateWaveQueue(config) {
    const el = instantiate('<a-entity wave-queue></a-entity>');
    this.el.appendChild(el);

    const onLoaded = () => {
      Object.keys(config).forEach(generatorName => {
        const generatorConfig = config[generatorName];
        el.setAttribute(generatorName, generatorConfig);
      });
      el.removeEventListener('loaded', onLoaded);
    };
    el.addEventListener('loaded', onLoaded);

    return el;
  },
});

export default {
  get instance() {
    return instance;
  },
};
